module.exports = __webpack_public_path__ + "img/image-thumb-22.38512b15.webp";